var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43214 0.691406L5.14286 1.25H1.28571C0.574554 1.25 0 1.80859 0 2.5C0 3.19141 0.574554 3.75 1.28571 3.75H16.7143C17.4254 3.75 18 3.19141 18 2.5C18 1.80859 17.4254 1.25 16.7143 1.25H12.8571L12.5679 0.691406C12.3509 0.265625 11.9049 0 11.4188 0H6.58125C6.09509 0 5.64911 0.265625 5.43214 0.691406ZM16.7143 5H1.28571L2.1375 18.2422C2.20179 19.2305 3.04554 20 4.06205 20H13.9379C14.9545 20 15.7982 19.2305 15.8625 18.2422L16.7143 5Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolid);
export default __webpack_public_path__ + "static/media/trash-solid.e7a946a3aea5296ae5e2c0663fb60fe7.svg";
export { ForwardRef as ReactComponent };